import config from '../../config/config';
import { getStore } from '../../store';
import { rendererHeaders } from '../helpers/app-services/AppServices/index';
import * as tokenHelper from '../helpers/TokenHelper';
import { rateLimitedfetch } from '../helpers/requestLimiter';

const { CHECKOUT_API_URL } = config;

export const fetchWithApiToken = (path, token, method = 'GET', headers = {}, body) => {
  if (token) {
    headers['x-spk-auth-token'] = token;
  }
  return rateLimitedfetch(`${CHECKOUT_API_URL}${path}`, {
    method,
    headers: { ...headers },
    body: JSON.stringify(body)
  }).then(res => res.json());
};

export const getPaymentCardParams = currencyCode => {
  const { auth } = getStore().getState();
  const { token } = auth.currentUser;
  const authToken = token || tokenHelper.getSparkolToken();
  const headers = rendererHeaders(true);
  const url = `/api/payment-card-params?app=scribely&currencyCode=${currencyCode}&useIngenico=true`;

  return fetchWithApiToken(url, authToken, 'GET', headers);
};

export const createNewCustomerOrder = (paymentRef, licenceType) => {
  const { auth, location } = getStore().getState();
  const { token } = auth.currentUser;
  const authToken = token || tokenHelper.getSparkolToken();
  const headers = rendererHeaders(true);
  const url = `/api/orders`;

  return fetchWithApiToken(url, authToken, 'POST', headers, {
    paymentRef,
    licenceType,
    location,
    currentUser: auth.currentUser,
    useV2: true
  });
};

export const getExistingPaymentMethod = async () => {
  const { token } = getStore().getState().auth.currentUser;
  const authToken = token || tokenHelper.getSparkolToken();
  const headers = rendererHeaders(true);
  const url = `/api/payment-method?app=scribely`;

  headers['x-spk-auth-token'] = authToken;
  const response = await rateLimitedfetch(`${CHECKOUT_API_URL}${url}`, {
    method: 'GET',
    headers
  });

  if (response.status === 204) {
    return null;
  }

  return response.json();
};

export const upgradeExistingAccountMethod = licenceType => {
  const { auth, payment } = getStore().getState();
  const { postcode, country, state, currency } = payment.existingPaymentDetails;
  const { token } = auth.currentUser;
  const authToken = token || tokenHelper.getSparkolToken();
  const headers = rendererHeaders(true);
  const url = `/api/orders`;

  return fetchWithApiToken(url, authToken, 'POST', headers, {
    licenceType,
    location: {
      postcode,
      country,
      state,
      currency
    },
    currentUser: auth.currentUser,
    useV2: true
  });
};
